module.exports = __webpack_public_path__ + "media/images/icon-terms@3x-5f928ed9974a1717032c6120d6342237.png";